import callAPiBase from './base';

const terminalBlocksApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/blockList',
      method: 'GET',
      useToken: true,
      title: 'Terminal Blocks - Get',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/blockCreate',
      method: 'POST',
      useToken: true,
      title: 'Terminal Blocks - Create',
      data,
    }),
  toggle: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/blockScheduleToggleStatus',
      method: 'PATCH',
      useToken: true,
      title: 'Terminal Blocks Schedule - Toggle Status',
      data,
    }),
  toggleTerminalPanic: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/terminalTogglePanic',
      method: 'POST',
      useToken: true,
      title: 'Terminal Toggle Panic',
      data,
    }),
  createSchedule: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/blockScheduleCreate',
      method: 'POST',
      useToken: true,
      title: 'Terminal Blocks Schedule - Create',
      data,
    }),
  updateSchedule: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/blockScheduleUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Terminal Blocks Schedule - Update',
      data,
    }),
  scheduleGateCreate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/blockScheduleGateCreate',
      method: 'POST',
      useToken: true,
      title: 'Terminal Blocks Schedule Gate - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/blockUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Terminal Blocks - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/blockDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Terminal Blocks - Delete',
      params,
    }),
  deleteSchedule: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/blockScheduleDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Terminal Blocks Schedule - Delete',
      params,
    }),
};

export { terminalBlocksApi };
export default terminalBlocksApi;
